<template>
  <div class="alert" v-bind:class="_class">
    <p class="alert__title">{{ title }}</p>
    <p class="alert__subtitle">{{ text }}</p>
    <button type="button" class="alert__close" v-on:click="$root.alert.type = null"><icon-x></icon-x></button>
  </div>
</template>

<script>
  export default {
    props: ['title', 'text', '_class'],

  }
</script>
